var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { useTheme } from "styled-components";
import { Box } from "../Box";
import { Label } from "../Text";
import { Flex } from "../Flex";
import { WizardAlign } from "./types";
export var WizardStepStatusType;
(function (WizardStepStatusType) {
    WizardStepStatusType["COMPLETED"] = "completed";
    WizardStepStatusType["CURRENT"] = "current";
    WizardStepStatusType["PENDING"] = "pending";
})(WizardStepStatusType || (WizardStepStatusType = {}));
const CurrentStepCircle = () => {
    const { colors: { wizardColors }, } = useTheme();
    const currentStepByStatusStyles = {
        backgroundColor: wizardColors.currentBackground,
        border: "4px solid",
        borderColor: wizardColors.currentCircleBorder,
        borderRadius: "50%",
        boxSizing: "border-box",
        marginLeft: "3px",
        marginTop: "3px",
    };
    return (React.createElement(Box, { "data-testid": "CurrentStepCircle", width: "32px", height: "32px", border: `1px solid ${wizardColors.currentStepBorder}`, borderRadius: "50%", boxShadow: `0px 0px 4px ${wizardColors.currentStepBorder}80`, minWidth: "32px" },
        React.createElement(Box, { mr: 2, height: "24px", width: "24px", sx: currentStepByStatusStyles })));
};
const StepCircle = ({ status = WizardStepStatusType.PENDING }) => {
    const { colors: { wizardColors }, } = useTheme();
    const stepByStatusStyles = {
        [WizardStepStatusType.COMPLETED]: {
            backgroundColor: wizardColors.completedBackground,
            borderRadius: "50%",
        },
        [WizardStepStatusType.CURRENT]: {
            backgroundColor: wizardColors.currentBackground,
            border: "4px solid",
            borderColor: wizardColors.currentCircleBorder,
            borderRadius: "50%",
            boxSizing: "border-box",
            marginLeft: "3px",
            marginTop: "3px",
        },
        [WizardStepStatusType.PENDING]: {
            backgroundColor: wizardColors.pendingBackground,
            borderRadius: "50%",
        },
    };
    return (React.createElement(Box, { border: "3px solid transparent", "data-testid": "WizardStepCircle", height: "32px", width: "32px", minWidth: "32px", sx: stepByStatusStyles[status] }));
};
export const WizardStep = (_a) => {
    var { stepLabel, children, onClick, status = WizardStepStatusType.PENDING, align = WizardAlign.Horizontal, stepNumber, showLabel = true, showSeparation = true } = _a, props = __rest(_a, ["stepLabel", "children", "onClick", "status", "align", "stepNumber", "showLabel", "showSeparation"]);
    const { colors: { wizardColors }, } = useTheme();
    const stepLabelCurrent = {
        color: wizardColors.stepLabelCurrent,
        fontWeight: "normal",
        lineHeight: "15px",
    };
    const stepLabelStyle = {
        color: wizardColors.stepLabelStyle,
        fontSize: 0,
        fontWeight: "normal",
        whiteSpace: "nowrap",
    };
    const verticalLine = {
        marginLeft: "13px",
        minHeight: "20px",
        padding: "0px 2px",
        width: "4px",
    };
    const horizontalLine = {
        marginLeft: "15px",
        minWidth: "20px",
        padding: "2px 0px",
    };
    const separatorLine = {
        backgroundColor: wizardColors.separatorLine,
        flexGrow: 1,
    };
    const separatorLineByStatus = {
        [WizardStepStatusType.COMPLETED]: Object.assign(Object.assign({}, separatorLine), { backgroundColor: wizardColors.separatorLineCompleted }),
        [WizardStepStatusType.CURRENT]: Object.assign(Object.assign({}, separatorLine), { backgroundColor: wizardColors.separatorLineCurrent }),
        [WizardStepStatusType.PENDING]: Object.assign(Object.assign({}, separatorLine), { backgroundColor: wizardColors.separatorLinePending }),
    };
    return (React.createElement(Flex, Object.assign({ mx: 2, alignItems: align === WizardAlign.Vertical ? "center" : "", flexDirection: align, flexGrow: showSeparation ? 1 : 0, maxHeight: 150, "data-testid": "WizardStep", onClick: onClick }, props),
        React.createElement(Flex, { alignItems: "center", style: { gap: "10px", padding: "15px 0px" } },
            status === WizardStepStatusType.CURRENT ? React.createElement(CurrentStepCircle, null) : React.createElement(StepCircle, { status: status }),
            showLabel && (React.createElement(Flex, { flexGrow: showSeparation ? 0 : 1, flexDirection: "column" },
                React.createElement(Label, Object.assign({ mr: 1 }, stepLabelStyle), `${stepLabel} ${stepNumber + 1}`),
                children && (React.createElement(Label, Object.assign({ "data-testid": "WizardStepLabel" }, stepLabelCurrent), children))))),
        showSeparation && (React.createElement(Box, { sx: Object.assign(Object.assign(Object.assign({}, separatorLineByStatus[status]), (align === WizardAlign.Horizontal ? verticalLine : horizontalLine)), { borderRadius: !showLabel && WizardAlign.Horizontal ? "8px" : "2px", height: !showLabel && WizardAlign.Horizontal ? "8px" : "initial" }) }))));
};
